import { render, staticRenderFns } from "./CommentSettingsModal.vue?vue&type=template&id=179841d8&lang=pug"
import script from "./CommentSettingsModal.vue?vue&type=script&lang=js"
export * from "./CommentSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./CommentSettingsModal.vue?vue&type=style&index=0&id=179841d8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports